import { Stack } from '@ltvco/refresh-lib/theme';
import {
  ListAction,
  MonitorAction,
  MoreAction,
  PdfAction,
  SaveAction,
  RECENT_REPORTS_DATA_MATCHER,
  type RecentReportSerialized,
  type MenuItem,
} from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';

const hidePDFReportTypes = [
  'username',
  'obituary',
  'unclaimed money',
  'ancestor',
];

const hideNotesReportTypes = ['unclaimed money'];

const fraudReportTypes = [
  'phone fraud',
  'email fraud',
  'ip fraud',
  'url fraud',
];

interface ReportCardActionsBaseProps {
  permalink: string;
  reportType: string;
  reportTitle: string;
  deleteCurrentReport: (permalink: string) => void;
  report?: RecentReportSerialized;
}

export const ReportCardActions = ({
  permalink,
  reportType: rawReportType,
  reportTitle,
  deleteCurrentReport,
  report,
}: ReportCardActionsBaseProps) => {
  const isInListV2Variation = useFeatureIsOn('prop-2834');

  const reportType = rawReportType.replace('_report', '').replace(/_/g, ' ');
  const isCollectionRecord = rawReportType.startsWith('fam_');

  const hidePDF =
    fraudReportTypes.includes(reportType) ||
    hidePDFReportTypes.includes(reportType);

  const hideMonitorForMultiState =
    reportType === 'unclaimed money' && permalink.length > 54;

  const filterMenuItems = (items: MenuItem[]) =>
    items.filter(
      (item) =>
        (item.display === 'Notes' &&
          !hideNotesReportTypes.includes(reportType) &&
          !isCollectionRecord) ||
        item.display === 'Delete'
    );

  const buildReportDataForListV2 = () => {
    if (!report) return undefined;
    const matcher = RECENT_REPORTS_DATA_MATCHER[reportType];
    if (matcher) {
      return matcher(report);
    }
  };

  return (
    <Stack
      direction={isCollectionRecord ? 'row-reverse' : 'row'}
      spacing={1}
      sx={{ ml: '-7px' }}
    >
      {!isCollectionRecord && (
        <SaveAction
          reportPermaLink={permalink}
          onReportCard
          disableCollapse
          reportType={reportType}
          section="recent_reports_rats"
          eventName="feature_engagement"
          reportDataForListV2={
            isInListV2Variation ? buildReportDataForListV2() : null
          }
        />
      )}
      {reportType !== 'username' &&
        !hideMonitorForMultiState &&
        !isCollectionRecord && (
          <MonitorAction
            reportPermaLink={permalink}
            reportType={reportType}
            onReportCard
            disableCollapse
            section="recent_reports_rats"
            eventName="feature_engagement"
          />
        )}
      {!isCollectionRecord && (
        <ListAction
          reportTitle={reportTitle}
          reportPermalink={permalink}
          onReportCard
          disableCollapse
          reportType={reportType}
          section="recent_reports_rats"
          eventName="feature_engagement"
          reportDataForListV2={
            isInListV2Variation ? buildReportDataForListV2() : null
          }
        />
      )}
      {!hidePDF && !isCollectionRecord && (
        <PdfAction
          reportPermalink={permalink}
          onReportCard
          disableCollapse
          reportType={reportType}
          section="recent_reports_rats"
          eventName="feature_engagement"
        />
      )}
      <MoreAction
        filterMenuItems={filterMenuItems}
        deleteCurrentReport={() => deleteCurrentReport(permalink)}
        reportPermaLink={permalink}
        reportType={reportType}
        onReportCard
        disableCollapse
        section="recent_reports_rats"
        eventName="feature_engagement"
        reportDataForListV2={
          isInListV2Variation ? buildReportDataForListV2() : null
        }
      />
    </Stack>
  );
};
